import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  handleSwalMessage,
  isHttpCodeSuccess,
} from "../../../Helpers/Http.commons";
import "../../../components/core/AccessRepositories/AccessRepositories.css";
import { fetchRepositoryAccess } from "../../../redux/slices/RepositorysSlice";
import { useAppDispatch } from "../../../redux/store/store";
import SpinnerButton from "../SpinnerButton/SpinnerButton";

const AccessRepositories = () => {
  const id = sessionStorage.getItem("selectedRepositoryId") || "";
  const name = sessionStorage.getItem("selectedRepositoryName");
  const description = sessionStorage.getItem("selectedRepositoryDescription");
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [formObject, setFormObject] = useState({
    repositoryId: id,
    requestedAccess: "",
  });
  const [radioValue, setRadioValue] = useState("");
  const navigate = useNavigate();

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRadioValue(event.target.value);
    sessionStorage.setItem("radioValue", radioValue);
    setFormObject({ ...formObject, requestedAccess: event.target.value });
  };

  const handleAccessRequest = () => {
    dispatch(
      fetchRepositoryAccess({
        formObject,
      })
    ).then((responseData) => {
      if (fetchRepositoryAccess.fulfilled.match(responseData)) {
        const { statusCode, error } = responseData.payload;
        const message = 'Se ha enviado tu solicitud de acceso correctamente.'
        const swalData: any = handleSwalMessage(responseData.payload, error || message);
        Swal.fire(swalData);

        if (isHttpCodeSuccess(statusCode)) navigate("/my-repositories");
      } else if (fetchRepositoryAccess.rejected.match(responseData)) {
        Swal.fire({
          icon: "error",
          title: "Error de Conexión",
          text: "Revise su conexión a internet y vuelva a intentar",
        });
      }
      setLoading(false);
    });
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);

    try {
      if (!buttonClicked) {
        setLoading(true);
        setButtonClicked(true);
      }

      handleAccessRequest();
    } catch (error) {
      console.error("Unexpected error:", error);
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error inesperado",
        text: "Ocurrió un error inesperado. Por favor, inténtelo de nuevo más tarde.",
      });
    }
  };

  return (
    <div className="access-cardcontainer">
      <div className="pds-card pds-productCard access-productCard">
        <form
          noValidate
          data-gtm-form="pdsFormAdditionalButtonCenterAlign"
          name="pdsFormAdditionalButtonCenterAlign"
          className="pds-form-wrapper pds-form-additional-button"
          action="#"
          onSubmit={handleSubmit}
        >
          <div
            className="pds-card-section pds-card-bg-primary-blue-2 access-productCard"
            tabIndex={0}
          >
            <h3 className="pds-card-title pds-typography-truncate access-productCard">
              &nbsp;Solicitud de Acceso a Repositorio
            </h3>
            <p className="pds-typography-body-14 access-productCard">
              (*) Para continuar con la solicitud favor selecciona un tipo de
              permiso
            </p>
          </div>
          <div className="pds-card-section access-productCard">
            <dl className="pds-gridTable access-productCard" tabIndex={0}>
              <div className="row-name-repository access-productCard">
                <dt className="pds-gridTable-data col-xs-12 col-sm-6 access-productCard ">
                  <span className="pds-typography-eyebrow-2 access-productCard">
                    Descripcion
                  </span>
                </dt>
                <dd className="pds-gridTable-data col-xs-12 col-sm-6 ">
                  <span className="pds-typography-eyebrow-2 access-productCard">
                    {description}
                  </span>
                </dd>
              </div>
              <div className="row-description access-productCard">
                <dt className="pds-gridTable-data col-xs-12 col-sm-6 access-productCard">
                  <span className="pds-typography-eyebrow-2 access-productCard">
                    Nombre del Repositorio
                  </span>
                </dt>
                <dd className="pds-gridTable-data col-xs-12 col-sm-6 access-productCard">
                  <span className="pds-typography-eyebrow-2 access-productCard">
                    {name}
                  </span>
                </dd>
              </div>
              <div className="row-type-permission access-productCard">
                <dt className="pds-gridTable-data col-xs-12 col-sm-6 access-productCard">
                  <span className="pds-typography-eyebrow-2 access-productCard">
                    Permisos a Solicitar
                  </span>
                  &nbsp;
                  <span
                    className="pds-tooltip pds-util-inline-flex pds-util-margin-right-16 pds-typography-eyebrow-2 access-productCard"
                    data-tippy-content="Solo puedes solicitar 2 tipos de permisos, Lectura y Escritura o Solo Lectura"
                    data-tippy-placement="right"
                  >
                    <i data-feather="help-circle" aria-hidden="true" />
                  </span>
                </dt>
                <dd className="pds-gridTable-data col-xs-12 col-sm-6 access-productCard ">
                  <div className="pds-form-field access-productCard">
                    <span className="radiovalue-permission access-productCard">
                      <div className="pds-radio access-productCard">
                        <input
                          name="pdsRadioOptions"
                          type="radio"
                          id="pdsForm-pdsRadioOptions1"
                          value="readonly"
                          checked={radioValue === "readonly"}
                          onChange={handleRadioChange}
                          defaultChecked
                        />
                        <label
                          htmlFor="pdsForm-pdsRadioOptions1"
                          className="pds-typography-eyebrow-2 label-read"
                        >
                          <span>Solo Lectura</span>
                        </label>
                        <input
                          name="pdsRadioOptions"
                          type="radio"
                          id="pdsForm-pdsRadioOptions2"
                          value="fullaccess"
                          checked={radioValue === "fullaccess"}
                          onChange={handleRadioChange}
                        />
                        <label
                          htmlFor="pdsForm-pdsRadioOptions2"
                          className="pds-typography-eyebrow-2 label-fullaccess"
                        >
                          <span>Lectura y Escritura</span>
                        </label>
                      </div>
                    </span>
                  </div>
                </dd>
              </div>
              <div className="row">
                <dt className="pds-gridTable-data col-xs-12 col-sm-6 access-productCard"></dt>
                <dd className="pds-gridTable-data col-xs-12 col-sm-6 row-button-container access-productCard">
                  <button
                    className="pds-button pds-button-primary button-access access-productCard"
                    disabled={loading || buttonClicked}
                    type="submit"
                  >
                    <i
                      data-feather="unlock"
                      aria-hidden="true"
                      className="icon-access"
                    ></i>
                    {loading ? <SpinnerButton /> : " Solicitar Acceso"}
                  </button>
                </dd>
              </div>
            </dl>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AccessRepositories;
